export default __webpack_public_path__ + "static/media/practicePage.bfd78dae.png";